"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voucher_status = exports.voucher = void 0;
exports.voucher = "/api/vouchers/{vendor_id}/{offer_id}/{voucher_code}";
exports.voucher_status = "/api/vouchers/public-status/{vendor_id}/{offer_id}";
